window.number_format = function (number, decimals = 0, dec_point = '.', thousands_sep = ',') {
	let sign = number < 0 ? '-' : '';

	let s_number = Math.abs(parseInt(number = (+number || 0).toFixed(decimals))) + "";
	let len = s_number.length;
	let tchunk = len > 3 ? len % 3 : 0;

	let ch_first = (tchunk ? s_number.substr(0, tchunk) + thousands_sep : '');
	let ch_rest = s_number.substr(tchunk)
		.replace(/(\d\d\d)(?=\d)/g, '$1' + thousands_sep);
	let ch_last = decimals ?
		dec_point + (Math.abs(number) - s_number)
			.toFixed(decimals)
			.slice(2) : '';

	return sign + ch_first + ch_rest + ch_last;
};
window.output_numbers = function (n, decimals = 0) {
	let val = number_format(n, decimals, '.', ' ');

	if (decimals > 0) {
		let regexp = "\\." + ("0".repeat(decimals));
		let findRegexp = new RegExp(regexp);
		val = val.replace(findRegexp, '');
	}

	return val;
};
window.output_money = function (money) {
	return output_numbers(money, 2) + ' р';
};

window.getWordForm = function (n, forms) {
	if (n > 0) {
		n = Math.abs(n) % 100;
		n1 = n % 10;
		if (n > 10 && n < 20) return forms[2];
		if (n1 > 1 && n1 < 5) return forms[1];
		if (n1 === 1) return forms[0];
	}
	return forms[2];
};

window.wordform_products_count = function (cnt) {
	return getWordForm(cnt, ['товар', 'товара', 'товаров']);
};
window.output_products_count = function (cnt) {
	return cnt + ' ' + wordform_products_count(cnt);
};

window.popupwindow = function (url, title, w, h) {
	let left = (screen.width / 2) - (w / 2),
		top = (screen.height / 2) - (h / 2);

	return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
};
